import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { riskComplianceBasePath } from './riskCompliancePaths';
import { useRiskComplianceErrorMessage } from './useRiskComplianceErrorMessage';

export const fetchCustomerRiskCompliance = async ({ queryKey }) => {
  const profileId = queryKey[1];
  const { data } = await apiClient.get(riskComplianceBasePath(profileId));
  return data;
};

export const useGetCustomerRiskComplianceHandler = (profileId, enabled = true) => {
  const dispatch = useDispatch();
  const getErrorMessage = useRiskComplianceErrorMessage();
  const shownErrorKeyRef = useRef(null);

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['customers', profileId, 'crif', 'risk-compliance'],
    queryFn: fetchCustomerRiskCompliance,
    enabled: Boolean(profileId) && enabled,
    staleTime: 60 * 1000,
    retry: 1,
  });

  useEffect(() => {
    if (!isError) {
      shownErrorKeyRef.current = null;
      return;
    }

    const errorKey = error?.response?.data?.code || error?.message;
    if (!errorKey || shownErrorKeyRef.current === errorKey) {
      return;
    }

    shownErrorKeyRef.current = errorKey;
    dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
  }, [dispatch, error, getErrorMessage, isError]);

  return {
    riskComplianceData: data,
    isLoading,
    isError,
    refetch,
  };
};
